import React, { useContext, useEffect, useMemo, useState } from "react";

import DocumentosList from "../../components/documentosList/DocumentosList";

import activoContext from "../../context/activoContex/activoContex";
import usuariosContext from "../../context/usuarios/usuariosContext";
import authContext from "../../context/authentication/authContex";
import controlContext from "../../context/control/controlContext";


import SearchInput from "../../components/searchInput/SearchInput";
import FilterScreen from "../../components/filterScreen/FilterScreen";
import AddFilter from "../../components/addFilter/AddFilter";

import './Documentos.css';
import { ALERTSProcedimientosProgramados, TIPPROCS } from "../../utils/states";
import ModalForm from "../../components/modalForm/ModalForm";
import { useLocation } from "react-router-dom";


const Documentos = () =>{
    const location = useLocation();
    //Recupera el codigo de activo para usarlo como filtro, caso que no este seteado se recibe null.
    const [filterByCodActivo,setFilterByCodActivo] = useState( localStorage.getItem('activoToSearch') || location?.state?.activoToSearch || null);
    const [wSpaceFromActivos,setWSpaceFromActivos] = useState( localStorage.getItem('workspaceSelected') || location?.state?.workspaceSelected || null);

    const documentosListFromLocalStorage = useMemo(()=>localStorage.getItem('documentosList'),[]);
    
    const [docsFiltrados,setDocsFiltrados] = useState(undefined);
    const [select,setSelect] = useState([]);
    //Si filterByCodActivo distinto de null se usa como filtro, si no se inicializa el filtro en ''.
    const [filter,setFilter] = useState(filterByCodActivo ? filterByCodActivo : '');
    const [showFilters,setShowFilter] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [activeWorkSpace, setActiveWorkSpace] = useState((wSpaceFromActivos == null ) ? {todos: 1, vencidos: 0, porVencer:0 } : {todos: (wSpaceFromActivos == 'todos') ? 1 : 0, vencidos: (wSpaceFromActivos == 'vencidos') ? 1 : 0, porVencer: (wSpaceFromActivos == 'porVencer') ? 1 : 0});
    const [fromActivoList,setFromActivoList] = useState((localStorage.getItem('activoToSearch') != null));

    const aContext = useContext(activoContext);
    const {activoList, docsXactivoList, getDocsXActivo, getDocFilesActivo} = aContext;
    //Los archivos de todos los documentos se pasaran luego, encargandose cada documento de filtrar el suyo.
    //Esto para evitar hacer una peticion al backend y al bucket S3 por cada documento.
    const [docFilesMap, setDocFilesMap] = useState({});

    const auContext = useContext(authContext);
    const { usuario } = auContext;

    const uContext = useContext(usuariosContext);
    const {userListView} = uContext

    const cContext = useContext(controlContext);
    const {
        listTDoc,
        filtrosRango, 
        filtrosEstado,
        modificarFiltrosEstado,
        modificarFiltrosRango,
        iniciarFiltros,
        getProductsByNroFor,
        filtrar,
        initialState
    } = cContext;

    const aplicarFiltros = async (filtrosProp) => {
        modificarFiltrosEstado(filtrosProp.filterEstado);
        modificarFiltrosRango(usuario._id, filtrosProp.filterRango);
    }

    const handleWorkSpace = (statusToDisplay) =>{
        let workspaceToSet = (statusToDisplay == 'todos') ? {todos: 1, vencidos: 0, porVencer: 0} : (statusToDisplay == 'vencidos') ? {todos: 0, vencidos: 1, porVencer: 0} : {todos: 0, vencidos: 0, porVencer: 1};
        let TIPOALERTA = (statusToDisplay == 'todos') ? ['VENC','PorVENC'] : (statusToDisplay == 'vencidos') ? ['VENC'] : ['PorVENC'];
        setActiveWorkSpace(workspaceToSet);
        const filterEstado = {...filtrosEstado, tipoAlerta: TIPOALERTA };
        const filterRango = initialState.filtrosRango;
        aplicarFiltros({filterRango, filterEstado},'');
    }

    const handlerIniciarlizarFiltros = async (statusToDisplay) => {
        const state = ALERTSProcedimientosProgramados;
        const tipoAlerta =(statusToDisplay != null) ? (statusToDisplay == 'todos') ? ['VENC','PorVENC'] : (statusToDisplay == 'vencidos') ? ['VENC'] : ['PorVENC'] : ALERTSProcedimientosProgramados;
        await iniciarFiltros(state, usuario, tipoAlerta, TIPPROCS, 'documentos');
    }

    useEffect(()=>{
        getDocsXActivo(); 
        handlerIniciarlizarFiltros(wSpaceFromActivos);
        //Al utilizarlo por unica vez se remueve nuevamente para no arrastrarlo a traves de todos los componentes.
        if(localStorage.getItem('activoToSearch')) localStorage.removeItem('activoToSearch');
        if(localStorage.getItem('workspaceSelected')) localStorage.removeItem('workspaceSelected');
        // if(documentosListFromLocalStorage != null && documentosListFromLocalStorage != 'null') localStorage.removeItem('documentosList');
    },[]);

    useEffect(()=>{
        if(docsXactivoList != undefined && docsXactivoList != null){
            let docsFiltradosToSet = filtrar((documentosListFromLocalStorage && documentosListFromLocalStorage != 'null') ? JSON.parse(documentosListFromLocalStorage) : docsXactivoList,filtrosEstado,filtrosRango,'Documentos');
            setDocsFiltrados(docsFiltradosToSet);

            const uniqueCodActivos = [...new Set(docsXactivoList.map(d => d.codActivo))];
            const fetchDocFiles = async () => {
                const map = {};
                await Promise.all(uniqueCodActivos.map(async (codActivo) => {
                    const files = await getDocFilesActivo(codActivo);
                    if(files && files.length > 0){
                        files.forEach(f => { map[`${codActivo}-${f.codDocumento}`] = f; });
                    }
                }));
                setDocFilesMap(map);
            };
            fetchDocFiles();
        };
    },[docsXactivoList,filtrosEstado,filtrosRango]);

    return <div className="documentosView">
        <div className="utilitiesDiv">
            <FilterScreen verFiltro={setShowFilter}/>
            <SearchInput filter={filter} buscar={setFilter}/>
        </div>
        <div className="handleWorkSpaceDiv">
            <label className={`${(Object.keys(activeWorkSpace).some(k => k == 'todos' && activeWorkSpace[k] == 1 )) && 'selected '} optionWorkspace`} onClick={()=>handleWorkSpace("todos")}>TODOS</label>
            <label className={`${(Object.keys(activeWorkSpace).some(k => k == 'vencidos' && activeWorkSpace[k] == 1 )) && 'selected '} optionWorkspace`} onClick={()=>handleWorkSpace("vencidos")}>VENCIDOS</label>
            <label className={`${(Object.keys(activeWorkSpace).some(k => k == 'porVencer' && activeWorkSpace[k] == 1 )) && 'selected '} optionWorkspace`} onClick={()=>handleWorkSpace("porVencer")}>POR VENCER</label>
        </div>
        {(docsFiltrados == undefined) ? <h3 className="messageDataView">Cargando...</h3> : (docsFiltrados.length == 0) ? <h3 className="messageDataView">No hay documentos que mostrar</h3> : <DocumentosList docsList={docsFiltrados} filter={filter} docFilesMap={docFilesMap}/>}
        {showFilters &&
        <div className="filterContainer">
            <AddFilter 
            usuarios={userListView} item={selectedFilter} 
            cerrar={setShowFilter} filtro={{filtrosRango, filtrosEstado}} aplicarFiltros={aplicarFiltros} 
            workspace={activeWorkSpace} selct={select} setSelec={setSelect} componentePadre="Documentos"/>
        </div>
        }
    </div>

}

export default Documentos;